import { render, staticRenderFns } from "./CasesTree.vue?vue&type=template&id=2b2979d6&scoped=true&"
import script from "./CasesTree.vue?vue&type=script&lang=ts&"
export * from "./CasesTree.vue?vue&type=script&lang=ts&"
import style0 from "./CasesTree.vue?vue&type=style&index=0&id=2b2979d6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b2979d6",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VTreeview } from 'vuetify/lib/components/VTreeview';
installComponents(component, {VTreeview})
